import React, { type ReactElement } from 'react';
import ConfirmModal, { ConfirmModalActionPair } from 'atom-components/confirm-modal';
import type { MarkResponseFormValues } from './mark-response-form.schema';
import { SubmitAction } from './mark-response-form.schema';

/**
 * Checks if the user should be asked before a mark is sent to review.
 */
export function shouldAskToSubmitForReview(
  canAdministrateMark: boolean,
  formValues: MarkResponseFormValues
): boolean {
  return (
    !canAdministrateMark &&
    formValues.submitAction === SubmitAction.SubmitMarking &&
    !!formValues.flagForAttention &&
    !formValues.submitForReview
  );
}

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function ConfirmSubmitForReviewModal({
  isOpen,
  onClose,
  onConfirm
}: Props): ReactElement {
  return (
    <ConfirmModal
      isOpen={isOpen}
      title="Confirm Submit for Review"
      handleClickCancel={onClose}
      handleClickOK={onConfirm}
      actionPair={ConfirmModalActionPair.Custom}
      buttonTitleOK="Confirm Submit for Review"
      buttonTitleCancel="Cancel"
    >
      <p>
        You've indicated that your mark needs review. You won't be able to make any further changes
        to this mark until a marking administrator returns it to you for further marking.
      </p>
      <p>Do you want to submit this mark for review?</p>
    </ConfirmModal>
  );
}
